export default __webpack_public_path__ + "static/media/acceptable_inactive.d6d786bc.svg";